import React from 'react';

export function isNewTabClick(event: React.MouseEvent<HTMLElement>): boolean {
  return event.ctrlKey || event.metaKey;
}

export const popEvent = (e: React.SyntheticEvent) => {
  e.preventDefault();
  e.stopPropagation();
};
